import { useQuery } from '@tanstack/react-query';
import { makeBookingManagerApi } from 'services/BookingManagerApi';

/**
 * React Query hook for fetching a single bank transaction by UUID
 *
 * @param uuid - The bank transaction UUID to fetch
 * @param enabled - Whether the query should be enabled (default: true)
 * @returns Query object with bank transaction data
 */
export const useBankTransaction = (uuid: string | undefined, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['bankTransaction', uuid],
    queryFn: async () => {
      if (!uuid) throw new Error('UUID is required');
      const api = makeBookingManagerApi();
      return api.getBankTransaction(uuid);
    },
    enabled: enabled && !!uuid,
  });
};

